export default function initCarrosselBlock() {
    const carrosselSections = document.querySelectorAll('[data-block="carrossel-imagens"]');

    carrosselSections.forEach(section => {
        const items = section.querySelectorAll('.pdr-carrossel__main-item');
        const thumbs = section.querySelectorAll('.pdr-carrossel__thumb-item');
        const thumbsContainer = section.querySelector('.pdr-carrossel__thumbs');
        const btnPrev = section.querySelector('.pdr-carrossel__nav--prev');
        const btnNext = section.querySelector('.pdr-carrossel__nav--next');
        let currentIndex = 0;

        /**
         * Move o scroll das miniaturas para garantir que o item ativo apareça
         */
        const syncThumbScroll = (index) => {
            const activeThumb = thumbs[index];
            if (!activeThumb || !thumbsContainer) return;

            const containerWidth = thumbsContainer.offsetWidth;
            const thumbLeft = activeThumb.offsetLeft;
            const thumbWidth = activeThumb.offsetWidth;
            const scrollTarget = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);

            thumbsContainer.scrollTo({
                left: scrollTarget,
                behavior: 'smooth'
            });
        };

        const updateCarrossel = (newIndex) => {
            items[currentIndex].classList.remove('is-active');
            thumbs[currentIndex].classList.remove('is-active');

            currentIndex = (newIndex + items.length) % items.length;

            items[currentIndex].classList.add('is-active');
            thumbs[currentIndex].classList.add('is-active');
            syncThumbScroll(currentIndex);
        };

        btnNext?.addEventListener('click', (e) => {
            e.preventDefault();
            updateCarrossel(currentIndex + 1);
        });

        btnPrev?.addEventListener('click', (e) => {
            e.preventDefault();
            updateCarrossel(currentIndex - 1);
        });

        // Eventos Click Thumbs
        thumbs.forEach((thumb, idx) => {
            thumb.addEventListener('click', () => {
                if (idx !== currentIndex) {
                    updateCarrossel(idx);
                }
            });
        });

        let touchStartX = 0;
        section.addEventListener('touchstart', e => touchStartX = e.changedTouches[0].screenX, {passive: true});
        section.addEventListener('touchend', e => {
            let touchEndX = e.changedTouches[0].screenX;
            if (touchStartX - touchEndX > 50) updateCarrossel(currentIndex + 1);
            if (touchEndX - touchStartX > 50) updateCarrossel(currentIndex - 1);
        }, {passive: true});
    });
}